import React, { useState } from "react";
import * as Popover from "@radix-ui/react-popover";
import clsx from "clsx";
import {
  LikeUpDefault,
  LikeUpActivated,
  LikeDownDefault,
  LikeDownActivated,
} from "../../assets/svgs/icons";
import OverlayPopover from "../overlay/Popover";

export interface ActionPopoverProps {
  type?: "like" | "dislike";
  size?: "sm" | "md";
  defaultOpen?: boolean;
  isActivated?: boolean; // 이미 좋아요/싫어요한 상태
  disabled?: boolean; // 이미 같은 반응을 한 경우 비활성화
  initialFeedback?: string; // 기존 피드백 (수정 모드용)
  onSave?: (feedback: string) => void;
  onCancel?: () => void;
  onOpen?: () => void; // 팝업 열릴 때 호출 (즉시 API 호출용)
}

const ActionPopover: React.FC<ActionPopoverProps> = ({
  type = "like",
  size = "sm",
  defaultOpen = false,
  isActivated = false,
  disabled = false,
  initialFeedback = "",
  onSave,
  onCancel,
  onOpen,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const [feedback, setFeedback] = useState(initialFeedback);

  const iconSize = size === "md" ? 24 : 20;

  const handleOpenChange = (newOpen: boolean) => {
    if (newOpen) {
      setFeedback(initialFeedback);
    }
    setOpen(newOpen);
    if (newOpen && !disabled && onOpen) onOpen();
  };

  const handleSave = () => {
    onSave?.(feedback);
    setFeedback("");
    setOpen(false);
  };

  const handleCancel = () => {
    onCancel?.();
    setFeedback("");
    setOpen(false);
  };

  // 타입에 따른 아이콘 선택
  const DefaultIcon = type === "like" ? LikeUpDefault : LikeDownDefault;
  const ActivatedIcon = type === "like" ? LikeUpActivated : LikeDownActivated;

  return (
    <Popover.Root open={open} onOpenChange={handleOpenChange}>
      <Popover.Trigger asChild>
        <button
          className={clsx(
            "box-border relative shrink-0 transition-colors",
            !disabled && "hover:opacity-70"
          )}
          aria-label={type === "like" ? "Like" : "Dislike"}
        >
          {open || isActivated ? (
            <ActivatedIcon width={iconSize} height={iconSize} />
          ) : (
            <DefaultIcon width={iconSize} height={iconSize} />
          )}
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content className="z-50" sideOffset={8} align="start">
          <OverlayPopover
            type={type}
            feedback={feedback}
            onFeedbackChange={setFeedback}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default ActionPopover;
